export default __webpack_public_path__ + "static/object-tile-size-light-38c669f30b68d037329c51095508880ecb5cba5bad207afef94c6e8ffb978fd5.png";